//This file is automatically rebuilt by the Cesium build process.
export default "const float czm_passOverlay = 9.0;\n\
";
